import React from 'react'
import PropTypes from 'prop-types'
import { Col, Row } from 'react-bootstrap'
import { NumberSelect } from 'components/forms'

const QuantityField = ({
  className,
  name,
  inputRef,
  quantityNeeded,
  purchaseQuantityLimit,
  showPurchaseQuantityLimit,
}) => (
  <Row className={className}>
    <Col xs={12}>
      <div className="mbs mtn">How many did you purchase?</div>
    </Col>
    <Col xs={12}>
      <NumberSelect
        help={
          showPurchaseQuantityLimit
            ? `Limit ${purchaseQuantityLimit} per customer`
            : `${quantityNeeded && `Still needs: ${quantityNeeded}`}`
        }
        size="small"
        min={1}
        max={
          showPurchaseQuantityLimit
            ? Math.min(purchaseQuantityLimit, quantityNeeded)
            : quantityNeeded
        }
        name={name}
        inputRef={inputRef}
      />
    </Col>
  </Row>
)

QuantityField.defaultProps = {
  className: undefined,
  name: undefined,
  inputRef: undefined,
}

QuantityField.propTypes = {
  className: PropTypes.string,
  name: PropTypes.string,
  inputRef: PropTypes.func,
  quantityNeeded: PropTypes.number.isRequired,
  purchaseQuantityLimit: PropTypes.number.isRequired,
  showPurchaseQuantityLimit: PropTypes.bool.isRequired,
}

export default QuantityField
